// @flow

import Service from './service';
import type { AddressType, AddressPayloadType } from '../types/address';
import type { ApiConstructorArgsType } from '../types/api';

export default class AddressService extends Service {
  constructor(args: ApiConstructorArgsType = {}) {
    super(args);
  }

  get(params: { member_id?: string }):Promise<AddressType> {
    const { member_id } = params;
    const url = member_id
      ? `member/${member_id}/address`
      : 'member/address';

    return this.api.get(`${this.baseUrl}/${url}`)
      .then(res => res.data);
  }

  save(payload: AddressPayloadType):Promise<{ address: AddressType }> {
    const { address: { id } } = payload;
    // POST to address creates a new address
    // PUT to address/:address_id updates a row in address table
    const apiCall = id
      ? this.api.put(`${this.baseUrl}/address/${id}`, payload)
      : this.api.post(`${this.baseUrl}/address`, payload);
    return apiCall.then(res => ({ address: res.data }));
  }

  saveToApp(payload: AddressPayloadType, params: Object = {}):Promise<{ address: AddressType }> {
    const { member_id } = params;
    const { app_ids = [] } = payload;
    if (!member_id || !app_ids.length) {
      return Promise.reject({ err: 'Req not sent, you did not specify any apps' });
    }
    return this.api.post(`${this.baseUrl}/member/${member_id}/address`, payload)
      .then(res => res.data);
  }

  saveMailingAddress(payload: AddressPayloadType,
    params: Object = {}):Promise<{ address: AddressType }> {
    const { member_id } = params;
    const { is_mailing } = payload;
    if (!member_id || !is_mailing) {
      return Promise.reject({ err: 'Req not sent, you did not specify if mailing address' });
    }
    return this.api.post(`${this.baseUrl}/member/${member_id}/address`, payload)
      .then(res => res.data);
  }

  deleteAddress(addressId: number): Promise<boolean> {
    return this.api.delete(`${this.baseUrl}/address/${addressId}`)
      .then(() => true)
      .catch(() => false);
  }
}
